/* Tysk katalog for locale-demo-reset-shortcut.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'demoReset.button': 'Demo zurücksetzen',
  'demoReset.title': 'Demounternehmen zurücksetzen',
  'demoReset.message': 'Dadurch werden alle Buchhaltungs- und Betriebsdaten in diesem Demounternehmen dauerhaft gelöscht. Die Aktion kann nicht rückgängig gemacht werden.',
  'demoReset.preserved': 'Unternehmensprofil, Mitglieder, Abonnement und Integrationsverbindungen bleiben erhalten.',
  'demoReset.phrase': 'BESTÄTIGEN',
  'demoReset.typeLabel': 'Gib {phrase} ein, um das Zurücksetzen zu aktivieren',
  'demoReset.typeHint': 'Prüfe, ob das richtige Demounternehmen ausgewählt ist, bevor du fortfährst.',
  'demoReset.confirm': 'Löschen und Demo zurücksetzen',
  'demoReset.complete': 'Das Demounternehmen wurde zurückgesetzt.',
  'demoReset.failed': 'Das Demounternehmen konnte nicht zurückgesetzt werden.',
  'demoReset.reason': 'Der Benutzer hat das schnelle Zurücksetzen des Demounternehmens durch Eingabe des erforderlichen Bestätigungsworts bestätigt.',
  'demoReset.settingTitle': 'Schnellschaltfläche zum Zurücksetzen anzeigen',
  'demoReset.settingHelp': 'Zeigt „Demo zurücksetzen“ über SuperPlumma für dieses Unternehmen an. Andere Unternehmen im Demokonto werden separat gesteuert.',
  'demoReset.settingEnabled': 'Die Schnellschaltfläche ist für dieses Demounternehmen aktiviert.',
  'demoReset.settingDisabled': 'Die Schnellschaltfläche ist deaktiviert.',
});
